export function formatFeePercent(basisPoints: number): string {
    const remainder = basisPoints % 100;

    if (remainder === 0) {
        return String(basisPoints / 100);
    }

    const whole = Math.floor(basisPoints / 100);
    return `${whole}.${String(remainder).padStart(2, '0')}`;
}
